import Model from 'flarum/common/Model';
export default class PostReaction extends Model {
  reaction() {
    return Model.attribute('reaction').call(this);
  }
  userId() {
    return Model.attribute('userId').call(this);
  }
  postId() {
    return Model.attribute('postId').call(this);
  }
  reactionId() {
    return Model.attribute('reactionId').call(this);
  }
  user() {
    return Model.hasOne('user');
  }
  post() {
    return Model.hasOne('post');
  }
}
flarum.reg.add('ziiven-ziven-reactions', 'forum/models/PostReaction', PostReaction);